import { TreeSelectProps } from 'antd';

import { ProductExclusion } from 'codegen';
import {
  InitialTableActions,
  TColumn,
  TEditableColumn,
  TFieldProps,
} from 'types';

export const columns = (retailers?: TreeSelectProps['treeData']): TEditableColumn<ProductExclusion>[] => [{
  width: 80,
  title: 'Type',
  dataIndex: 'type',
  filters: Object.values(ProductExclusion.type).map((type) => ({ text: type, value: type })),
  onFilter: (value, record) => record.type.startsWith(String(value)),
  field: {
    type: TFieldProps.type.Select,
    options: Object.values(ProductExclusion.type).map((type) => ({ label: type, value: type })),
    allowClear: false,
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}, {
  width: 250,
  title: 'Value',
  dataIndex: 'value',
  sorter: (a, b) => a.value.localeCompare(b.value),
  field: {
    type: TFieldProps.type.Text,
    placeholder: 'Fill the value',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}, {
  type: TColumn.type.Tags,
  width: 350,
  title: 'Retailers',
  dataIndex: 'retailers',
  field: {
    type: TFieldProps.type.TreeSelect,
    treeData: retailers,
    placeholder: 'Select Retailer(s)',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}];

export const initialTableActions = [{
  type: InitialTableActions.Edit,
}, {
  type: InitialTableActions.Toggle,
  title: 'product exclusion',
}];
